import Grid from "@mui/material/Unstable_Grid2";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { Link, Link as RouterLink } from "react-router-dom";
import { useTheme } from "@mui/material/styles"

import { PostI, ReleasePost, StandardPost } from "./PostTypes";

const linkStyle = {
  fontWeight: 700,
  margin: "0 4px",
  textDecoration: "none",
};


export interface PostTitleProps {
  post: StandardPost | ReleasePost;
}

const PostTitle = (props: PostTitleProps) => {
  const theme = useTheme();
  let { post } = props;

  let title: string = post.title;
  let author: string | null = null;

  if (props.post.kind === "release") {
    post = post as unknown as ReleasePost;
    title = post.project;
    author = post.author;
  }


  // Add a non-breaking white space between any word "Chapter" or "Volume" so that
  // the title does not move one number below the title
  title = title.replace(/(Vol(?:ume)?|Chapter) (\d{1,5})/gi, "$1\u00A0$2")

  const postTitleLinkStyle = {
    color: "#fff",
    textDecoration: "none",
    ":hover": {
      color: theme.palette.primary.light
    }
  };

  return (
    <Grid container xs={12} justifyContent="center">
      <Stack sx={{ a: postTitleLinkStyle }}>
          <Stack direction="row" alignItems="baseline" spacing={1}>
          <Link to={`/posts/${props.post.id}`} style={{ ...linkStyle }}>
            <Typography variant="h4" component="h1">
              {/* T */}
              {title }
              {post.subtitle ? ":" : null}
            </Typography>
          </Link>            {post.subtitle ? (
              <Typography variant="h5" component="h3">
                {post.subtitle}
              </Typography>
            ) : null}
          </Stack>
        <Typography variant="h6" component="h2">
          {author}
        </Typography>
      </Stack>
    </Grid>
  );
};

export default PostTitle;
